import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
import channels from './channels'
import events from './events'
/**
* @see \App\Http\Controllers\Creator\CommunityController::index
* @see app/Http/Controllers/Creator/CommunityController.php:31
* @route '/app/creator/community'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/app/creator/community',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\CommunityController::index
* @see app/Http/Controllers/Creator/CommunityController.php:31
* @route '/app/creator/community'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\CommunityController::index
* @see app/Http/Controllers/Creator/CommunityController.php:31
* @route '/app/creator/community'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\CommunityController::index
* @see app/Http/Controllers/Creator/CommunityController.php:31
* @route '/app/creator/community'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\CommunityController::index
* @see app/Http/Controllers/Creator/CommunityController.php:31
* @route '/app/creator/community'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\CommunityController::index
* @see app/Http/Controllers/Creator/CommunityController.php:31
* @route '/app/creator/community'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\CommunityController::index
* @see app/Http/Controllers/Creator/CommunityController.php:31
* @route '/app/creator/community'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

const community = {
    index: Object.assign(index, index),
    channels: Object.assign(channels, channels),
    events: Object.assign(events, events),
}

export default community